import { profile } from '../../data/site';

function scrollToId(id) {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

/*--------------------
* Mid-page CTA band
----------------------*/
export default function Intrested() {
  return (
    <section className="py-10 lg:py-14">
      <div className="container">
        <div className="reveal glass card-sheen relative overflow-hidden px-7 py-10 lg:px-14 lg:py-14">
          {/* glow */}
          <div
            className="aurora h-[340px] w-[340px] bg-violet-brand/25"
            style={{ top: '-140px', right: '-60px' }}
            aria-hidden="true"
          />
          <div
            className="aurora h-[280px] w-[280px] bg-cyan-brand/20"
            style={{ bottom: '-140px', left: '-40px' }}
            aria-hidden="true"
          />

          <div className="relative z-[1] grid items-center gap-8 lg:grid-cols-12">
            <div className="lg:col-span-8">
              <span className="kicker">Next step</span>
              <h2 className="mt-4 font-display text-[28px] font-[600] leading-[1.15] tracking-[-.02em] text-chalk lg:text-[40px]">
                Got an app idea, or one that&rsquo;s{' '}
                <span className="grad-text">stuck in the build?</span>
              </h2>
              <p className="lede mt-4">
                Tell me what you&rsquo;re making. I&rsquo;ll come back with an honest read on
                scope, timeline and whether I&rsquo;m the right person for it.
              </p>
            </div>

            <div className="flex flex-wrap gap-3 lg:col-span-4 lg:justify-end">
              <button className="btn btn-primary" onClick={() => scrollToId('contact')}>
                Start a project
                <span aria-hidden="true">&rarr;</span>
              </button>
              <a className="btn btn-ghost" href={`mailto:${profile.email}`}>
                Email me
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
